import type { ModalFuncProps } from 'antd/es/modal/interface';
import type { TFunction } from 'i18next';

import AiSummary from '../../components/Ai/AiSummary';
import type File from '../../interfaces/File';

type ModalConfirm = (props: ModalFuncProps) => { destroy: () => void };

/**
 * Opens the AI summary modal for a file. Shared by the file actions menu and the
 * notifications system (toast and notification list click-through).
 */
export function openAiSummaryModal(params: {
  modal: { confirm: ModalConfirm };
  t: TFunction;
  file: File;
  onSummaryGenerated?: () => void;
}): void {
  const { modal, t, file, onSummaryGenerated } = params;
  const modalInstance = modal.confirm({
    title: t('modal.aiSummary.title') + ' - ' + file.fileName,
    width: 800,
    content: (
      <AiSummary
        file={file}
        onSummaryGenerated={onSummaryGenerated ?? (() => {})}
        onRequestClose={() => modalInstance.destroy()}
      />
    ),
    cancelText: t('common.close'),
    okButtonProps: { style: { display: 'none' } },
  });
}
